/* ============================================================
   PROTIV NUTRITION — THEME JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── HERO CAROUSEL ──────────────────────────────────────────
  const carousel = document.querySelector('.hero-carousel');
  if (carousel) {
    const slides    = carousel.querySelectorAll('.hero-slide');
    const dotsWrap  = carousel.querySelector('.hero-dots');
    const prevBtn   = carousel.querySelector('.hero-prev');
    const nextBtn   = carousel.querySelector('.hero-next');
    const slidesEl  = carousel.querySelector('.hero-slides');

    let current   = 0;
    let timer     = null;
    const DELAY   = 5500;

    // Build dots
    if (dotsWrap) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.classList.add('hero-dot');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        if (i === 0) dot.classList.add('active');
        dot.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(dot);
      });
    }

    function goTo(index) {
      slides[current].classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      slidesEl.style.transform = 'translateX(-' + (current * 100) + '%)';
      // Update dots
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.hero-dot').forEach((d, i) => {
          d.classList.toggle('active', i === current);
        });
      }
      resetTimer();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function resetTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, DELAY);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    // Touch swipe
    let touchStartX = 0;
    carousel.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? next() : prev();
    }, { passive: true });

    // Init
    slides[0].classList.add('active');
    resetTimer();

    // Pause on hover
    carousel.addEventListener('mouseenter', () => { if (timer) clearInterval(timer); });
    carousel.addEventListener('mouseleave', resetTimer);
  }

  // ── MOBILE MENU ────────────────────────────────────────────
  const menuToggle = document.querySelector('.nav-menu-toggle');
  const drawer     = document.querySelector('.nav-drawer');
  const overlay    = document.querySelector('.nav-drawer-overlay');
  const closeBtn   = document.querySelector('.nav-drawer-close button');

  function openDrawer() {
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openDrawer);
  if (overlay)    overlay.addEventListener('click', closeDrawer);
  if (closeBtn)   closeBtn.addEventListener('click', closeDrawer);

  // ── PRODUCT GALLERY ────────────────────────────────────────
  const thumbs    = document.querySelectorAll('.product-thumb');
  const mainImage = document.querySelector('.product-main-image img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImage) {
        mainImage.src = this.dataset.src || this.querySelector('img')?.src || mainImage.src;
      }
    });
  });

  // ── CART QUANTITY ──────────────────────────────────────────
  document.querySelectorAll('.cart-qty').forEach(qty => {
    const minus = qty.querySelector('[data-action="minus"]');
    const plus  = qty.querySelector('[data-action="plus"]');
    const count = qty.querySelector('.qty-count');
    const input = qty.querySelector('input[name="updates[]"]');

    if (minus && plus && count) {
      minus.addEventListener('click', () => {
        const val = Math.max(1, parseInt(count.textContent) - 1);
        count.textContent = val;
        if (input) input.value = val;
      });
      plus.addEventListener('click', () => {
        const val = parseInt(count.textContent) + 1;
        count.textContent = val;
        if (input) input.value = val;
      });
    }
  });

  // ── ADD TO CART AJAX ───────────────────────────────────────
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', function (e) {
      const variantId = this.dataset.variantId;
      if (!variantId) return; // Let form handle it on product page

      e.preventDefault();
      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        this.textContent = 'Added ✓';
        this.style.background = 'var(--green-mid)';
        updateCartCount();
        setTimeout(() => {
          this.textContent = originalText;
          this.style.background = '';
          this.disabled = false;
        }, 2200);
      })
      .catch(() => {
        this.textContent = originalText;
        this.disabled = false;
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  // ── EMAIL FORM ─────────────────────────────────────────────
  const emailForm = document.querySelector('.email-signup-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = this.querySelector('input[type="email"]').value;
      const btn   = this.querySelector('button');
      if (!email) return;

      btn.textContent = 'Done! Check your inbox.';
      btn.style.background = 'var(--green-mid)';
      btn.disabled = true;
      this.querySelector('input').value = '';
    });
  }

  // ── STICKY NAV SHADOW ──────────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 2px 16px rgba(0,0,0,0.06)'
        : 'none';
    }, { passive: true });
  }

  // ── ANNOUNCEMENT BAR DISMISS ───────────────────────────────
  const announceClose = document.querySelector('.announce-close');
  const announceBar   = document.querySelector('.announcement-bar');
  if (announceClose && announceBar) {
    announceClose.addEventListener('click', () => {
      announceBar.style.display = 'none';
      sessionStorage.setItem('announce_dismissed', '1');
    });
    if (sessionStorage.getItem('announce_dismissed')) {
      announceBar.style.display = 'none';
    }
  }

});
